var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('ol',{staticClass:"gradient-list"},[_c('h1',[_vm._v("Quizzes")]),_vm._l((_vm.quizzes),function(quiz,i){return _c('li',{key:i},[_c('router-link',{attrs:{"to":{
          name: 'showQuiz',
          params: {
            quizId: quiz._id,
          },
        }}},[_vm._v(" "+_vm._s(quiz.name)+" ")])],1)})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }